<template>
  <hlxlogin />
</template>

<script>
import hlxlogin from "../components/LoginComponent.vue";

export default {
  components: {
    hlxlogin,
  },
};
</script>

<style></style>
